export enum FeatureEnum {
    MY_ACCOUNT = 'my_account',
    HEADER_CAN_IMPERSONATE = 'header_can_impersonate',
    HEADER_CANNOT_IMPERSONATE = 'header_cannot_impersonate',
    MESSAGING = 'messaging',
    NURSERY_SETTINGS = 'nursery_settings',
    NURSERY_ENCODE = 'NURSERY_ENCODE',
    NURSERY_TABS = 'nursery_tabs',
    NURSERY_VIEW_SETTINGS = 'nursery_view_settings',
    NURSERY_QR = 'nursery_qr',
    NURSERY_DELETE = 'nursery_delete',
    WALLET_ADMIN = 'wallet_admin',
    WALLET_ACTION = 'wallet_action',
    WALLET_ACTION_EMPLOYEE = 'wallet_action_employee',
    WALLET_DASHBOARD = 'wallet_dashboard',
    WALLET_STUDENT = 'wallet_student',
    WALLET_DELETE_TRANSACTION = 'wallet_delete_transaction',
    WALLET_HISTORY_FILTER = 'wallet_history_filter',
    WALLET_VIEW_PRICE = 'wallet_view_price',
    WALLET_VIEW_STATUS = 'wallet_view_status',
    // REPERTOIRE
    // VIEW = permet de visualiser le résumé
    VIEW_SCHOOL = 'VIEW_SCHOOL',
    VIEW_ECHEVIN = 'VIEW_ECHEVIN',
    VIEW_DIRECTOR = 'VIEW_DIRECTOR',
    VIEW_ASSISTANT = 'VIEW_ASSISTANT',
    VIEW_SECRETARY = 'VIEW_SECRETARY',
    VIEW_TEACHER = 'VIEW_TEACHER',
    VIEW_SUPERVISOR = 'VIEW_SUPERVISOR',
    VIEW_PARENT = 'VIEW_PARENT',
    VIEW_STUDENT = 'VIEW_STUDENT',
    VIEW_CLASS = 'VIEW_CLASS',
    VIEW_CLASS_AS_PARENT = 'VIEW_CLASS_AS_PARENT',
    VIEW_GROUP_PERSO = 'VIEW_GROUP_PERSO',
    VIEW_GROUP_PREDEFINED = 'VIEW_GROUP_PREDEFINED',
    VIEW_CONTACT = 'VIEW_CONTACT',
    VIEW_RELATIVE = 'VIEW_RELATIVE',
    VIEW_RELATIVE_AS_EMPLOYEE = 'VIEW_RELATIVE_AS_EMPLOYEE',
    VIEW_ADRESS_PHONE = 'view_adress_phone',
    VIEW_RELATIVE_ADRESS_OR_PHONE = 'view_relative_adress_or_phone',
    VIEW_ADMIN = 'view_admin',
    // READ = permet de consulter la fiche détaillée
    READ_SCHOOL = 'READ_SCHOOL',
    READ_ECHEVIN = 'READ_ECHEVIN',
    READ_DIRECTOR = 'READ_DIRECTOR',
    READ_ASSISTANT = 'READ_ASSISTANT',
    READ_SECRETARY = 'READ_SECRETARY',
    READ_TEACHER = 'READ_TEACHER',
    READ_SUPERVISOR = 'READ_SUPERVISOR',
    READ_PARENT = 'READ_PARENT',
    READ_STUDENT = 'READ_STUDENT',
    READ_CLASS = 'READ_CLASS',
    READ_GROUP_PERSO = 'READ_GROUP_PERSO',
    READ_GROUP_PREDEFINED = 'READ_GROUP_PREDEFINED',
    READ_CONTACT = 'READ_CONTACT',
    READ_RELATIVE = 'READ_RELATIVE',
    // EDIT
    EDIT_SCHOOL = 'edit_school',
    EDIT_ECHEVIN = 'edit_echevin',
    EDIT_EMPLOYEE = 'edit_employee',
    EDIT_PARENT = 'edit_parent',
    EDIT_STUDENT = 'edit_student',
    EDIT_STUDENT_CALENDAR = 'edit_student_calendar',
    EDIT_RELATIVE = 'edit_relative',
    EDIT_RELATIVE_AS_EMPLOYEE = 'edit_relative_as_employee',
    EDIT_CONTACT = 'edit_contact',
    EDIT_GROUP = 'edit_group',
    EDIT_CLASS = 'edit_class',
    EDIT_ADMIN = 'edit_admin',
    EDIT_DIRECTOR = 'edit_director',
    EDIT_ASSISTANT = 'edit_assistant',
    EDIT_SECRETARY = 'edit_secretary',
    EDIT_TEACHER = 'edit_teacher',
    EDIT_SUPERVISOR = 'edit_supervisor',
    EDIT_GROUP_PERSO = 'edit_group_perso',
    EDIT_GROUP_PREDEFINED = 'edit_group_predefined',
    // CREATE
    CREATE_ENTITY = 'create_entity',
    CREATE_SCHOOL = 'create_school',
    CREATE_EMPLOYEE = 'create_employee',
    CREATE_PARENT = 'create_parent',
    CREATE_STUDENT = 'create_student',
    CREATE_RELATIVE = 'create_relative',
    CREATE_CONTACT = 'create_contact',
    CREATE_GROUP = 'create_group',
    CREATE_CLASS = 'create_class',
    CREATE_ADMIN = 'create_admin',
    // DELETE
    DELETE_STUDENT = 'delete_student',
    // END REPERTOIRE
    IS_ACTIVE_SWITCH_CHANGE = 'is_active_switch_change',
    SHOPPING_NAV = 'shopping_nav',
    MEALS_NAV = 'meals_nav',
    MEALS_TABS = 'meals_tabs',
    MEALS_TABS_AS_STUDENT = 'meals_tabs_as_student',
    MEALS_PARENT_DISCLAIMER = 'meals_parent_disclaimer',
    MEALS_ACCESS = 'meals_access',
    MEALS_ACCESS_AS_STUDENT = 'meals_access_as_student',
    MEALS_ACCESS_AS_PARENT = 'meals_access_as_parent',
    MEALS_BOOKING_EMPLOYEES = 'meals_booking_employees',
    MEALS_BOOKING_STUDENTS = 'meals_booking_students',
    MEALS_SETTINGS = 'meals_settings',
    MEALS_HISTORY = 'meals_history',
    MEALS_VIEW_SETTINGS = 'meals_view_settings',
    NURSERY_NAV = 'nursery_nav',
    ACTIVITIES_NAV = 'activities_nav',
    HOMEWORK_SCHOOL_NAV = 'homework_school_nav',
    HOMEWORK_SCHOOL_TABS = 'homework_school_tabs',
    HOMEWORK_SCHOOL_PARENT_DISCLAIMER = 'homework_school_parent_disclaimer',
    HOMEWORK_SCHOOL_ACCESS = 'homework_school_access',
    HOMEWORK_SCHOOL_BOOKING_EMPLOYEES = 'homework_school_booking_employees',
    HOMEWORK_SCHOOL_BOOKING_STUDENTS = 'homework_school_booking_students',
    HOMEWORK_SCHOOL_SETTINGS = 'homework_school_settings',
    HOMEWORK_SCHOOL_HISTORY = 'homework_school_history',
    HOMEWORK_VIEW_SETTINGS = 'homework_view_settings',
    HOMEWORK_CALENDAR_AS_PARENT = 'homework_calendar_as_parent',
    DELETE_ORDER = 'delete_order',
    ADMIN_SETTINGS = 'admin_settings',

    // EVENTS
    EVENTS_BOOKING_EMPLOYEES = 'events_booking_employees',
    EVENTS_FILTERS_EDUCATION_LEVEL = 'events_filters_education_level',
    // CLOUD
    CLOUD_NAV = 'cloud_nav',
    CLOUD_ACTIONS = 'cloud_actions',
    CLOUD_CREATE_FOLDER = 'cloud_create_folder',

    // CALENDAR
    CALENDAR_NAV = 'calendar_nav',

    OPEN_ACCESS = 'open_access',
    SHOPPING_EXPORT = 'shopping_export',
    SHOPPING_HISTORY_SEARCH = 'shopping_history_search',
    SHOPPING_CHARGE_DECHARGE = 'shopping_charge_decharge',
}
